import { createSelector } from 'reselect';

import getCategories from './getCategories';
import categoriesByName from '../../categories/helpers/categoriesByName';

export default createSelector([getCategories], categoriesByName);
